<template>
	<div class="desktop-layout">
		<top />
		<div
			class="desktop-layout__content"
			:class="{
				'desktop-layout__content--center-only': $route.meta.centerOnlyLayout,
				'desktop-layout__content--full':
					!$route.meta.showLeftNav && !$route.meta.showRightNav,
			}"
		>
			<div class="desktop-layout__content__left" v-if="$route.meta.showLeftNav">
				<live-sports-list v-if="$route.meta.showLiveNav" />
				<sports-list v-if="$route.meta.showPrematchNav" />
			</div>
			<div
				:class="{
					'desktop-layout__content__center': 1,
					'desktop-layout__content__center--only': $route.meta.centerOnlyLayout,
				}"
			>
				<keep-alive
					:include="[
						'home',
						'Jengabet',
						'boosted-multibet',
						'casino',
						'casino-category',
						'my-bets',
					]"
				>
					<router-view />
				</keep-alive>
			</div>
			<div
				class="desktop-layout__content__right"
				v-if="$route.meta.showRightNav"
			>
				<main-betslip v-if="$route.meta.showBetslip" />
			</div>
		</div>
		<button class="desktop-layout__backtotop" onclick="window.scrollTo(0, 0);">
			<svg
				class="desktop-layout__backtotop__icon"
				viewBox="0 0 11 11"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M0.820312 6.27344C0.914062 6.41406 1.05469 6.46094 1.21875 6.46094C1.35938 6.46094 1.5 6.39062 1.61719 6.27344L4.3125 3.46094V10.1875C4.3125 10.3516 4.35938 10.4922 4.47656 10.5859C4.57031 10.7031 4.71094 10.75 4.875 10.75H5.625C5.76562 10.75 5.90625 10.7031 6.02344 10.5859C6.11719 10.4922 6.1875 10.3516 6.1875 10.1875V3.46094L8.88281 6.27344C8.97656 6.39062 9.11719 6.46094 9.28125 6.46094C9.42188 6.46094 9.5625 6.41406 9.67969 6.27344L10.1953 5.75781C10.2891 5.66406 10.3594 5.52344 10.3594 5.35938C10.3594 5.21875 10.2891 5.07812 10.1953 4.96094L5.64844 0.414062C5.53125 0.320312 5.39062 0.25 5.25 0.25C5.08594 0.25 4.94531 0.320312 4.85156 0.414062L0.304688 4.96094C0.1875 5.07812 0.140625 5.21875 0.140625 5.35938C0.140625 5.52344 0.1875 5.66406 0.304688 5.75781L0.820312 6.27344Z"
				/>
			</svg>

			<span class="desktop-layout__backtotop__text">{{$t("general.back-to-top")}}</span>
		</button>
		<b-footer />
		<support-contacts v-if="env.supportContactsTab.enabled && contactsTabSupportsLayout"/>
		<zendesk-chat v-if="env.zendeskChat.enabled"/>
	</div>
</template>

<script>
import Top from "../components/Shared/Top.vue";
import MainBetslip from "../components/Betslip/MainBetslip.vue";
import SportsList from "../components/Prebets/SportsList.vue";
import LiveSportsList from "../components/Live/SportsList.vue";
import ZendeskChat from "../components/Shared/ZendeskChat.vue";
import BFooter from "./Footer.vue";
import SupportContacts from "../components/Shared/SupportContacts.vue";
export default {
	name: "desktop-layout",
	components: {
		Top,
		MainBetslip,
		SportsList,
		LiveSportsList,
		BFooter,
		ZendeskChat,
		SupportContacts,
	},
	mounted() {
		let vm = this;


		this.waitForZendesk(() => {
			zE('messenger', 'show')

			zE("messenger:on", "close", function () {
				zE('messenger', 'show')
			})
		})

		if (!vm.$store.getters["settings/settings"].autorefresh.status)
			vm.$store.commit("settings/toggleAutorefresh");
	},
	computed: {
		contactsTabSupportsLayout(){
			console.log("contactsTabSupportsLayout ",this.env.supportContactsTab.layouts.includes(this.$store.getters.layout));
			return this.env.supportContactsTab.layouts.includes(this.$store.getters.layout)
		}
	}
};
</script>

<style lang="scss">
.desktop-layout {
	margin-top: var(--desktop-header-offset);
	&__content {
		display: grid;
		grid-template-columns: 1fr 3fr 1.5fr;
		grid-template-rows: 1fr;
		gap: 0px 2px;
		grid-template-areas: ". . .";
		padding: 2px;
		min-height: calc(100vh - var(--desktop-header-offset));
		&--full {
			display: block;
		}
		&--center-only {
			grid-template-columns: 0.5fr 5fr 0.5fr;

			.desktop-layout__content__left,
			.desktop-layout__content__right {
				flex: 1;
				min-width: 0;
			}
		}
		&__left {
			flex: 1;
			min-width: 15vw;
		}
		&__center {
			flex: 3;
			min-width: 50vw;
		}
		&__right {
			flex: 2;
			min-width: 20vw;
		}
	}
	&__backtotop {
		border-radius: 50px;
		background: var(--white);
		color: var(--light-black);
		border: none;
		padding: 8px 25px;
		font-size: var(--font-small);
		margin: 0 auto;
		margin-left: 50%;
		transform: translateX(-125%);
		margin-bottom: 20px;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-top: 20px;
		&:hover {
			opacity: 0.9;
		}
		&__icon {
			path {
				fill: var(--light-black);
			}
			margin-right: 5px;
			height: 11px;
		}
	}
}
</style>
